import { Waves } from "lucide-react";
import { GULLY } from "@/lib/constants";

const ORDER = ["overflow", "surcharge", "elevated", "normal"];

export default function GullyFusion({ runoff, peak }) {
  const counts = runoff?.counts || {};
  const total = ORDER.reduce((a, k) => a + (counts[k] || 0), 0) || 1;
  const ratio = runoff?.max_ratio ?? 0;
  const worst = ORDER.find((k) => counts[k]) || "normal";
  return (
    <div data-testid="gully-fusion-panel" className="border-t border-border pt-3 flex flex-col gap-2">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5 font-mono-t text-[9px] uppercase tracking-widest text-slate-400">
          <Waves className="w-3 h-3 text-cyan" /> Gully network load
        </div>
        <span data-testid="gully-status-badge" className="font-mono-t text-[9px] uppercase tracking-widest px-1.5 py-0.5 rounded"
          style={{ color: GULLY[worst].color, background: `${GULLY[worst].color}1a` }}>
          {GULLY[worst].label}
        </span>
      </div>
      <div className="flex h-1.5 rounded overflow-hidden bg-slate-800" data-testid="gully-load-bar">
        {ORDER.map((k) => counts[k] ? (
          <div key={k} style={{ width: `${(counts[k] / total) * 100}%`, background: GULLY[k].color }} />
        ) : null)}
      </div>
      <div className="grid grid-cols-3 gap-2 font-mono-t text-[10px]">
        <Cell label="Peak load" value={`${ratio}×`} testid="gully-max-ratio" color={GULLY[worst].color} />
        <Cell label="Over bank" value={(counts.overflow || 0) + (counts.surcharge || 0)} testid="gully-surcharged-count" />
        <Cell label="Assets hit" value={runoff?.flagged_count ?? 0} testid="gully-assets-count" />
      </div>
      {peak && peak.max_ratio >= 0 && (
        <div data-testid="gully-peak-outlook" className="font-mono-t text-[9px] text-slate-500 leading-relaxed">
          72h peak: {peak.max_ratio}× bank-full @ +{peak.hour}h · {peak.assets_at_risk} assets in overflow zones
        </div>
      )}
    </div>
  );
}

function Cell({ label, value, testid, color = "#f8fafc" }) {
  return (
    <div data-testid={testid} className="bg-slate-900/60 border border-border rounded-md px-2 py-1.5">
      <div className="text-[8px] uppercase tracking-widest text-slate-500">{label}</div>
      <div className="font-heading font-bold text-sm" style={{ color }}>{value}</div>
    </div>
  );
}
